import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import { getSocket } from '../../common/AllSocketsMiddleware';

const apiCaller = getApiInstance();

function getBoxes() {
    return dispatch => {
        return apiCaller
            .call(api.getAllBoxes())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__SET_BOXES',
                        boxes: data.boxes
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheBoxes - ', error);
                throw error;
            });
    };
}
function getBoxDetails(macAddress) {
    return dispatch => {
        return apiCaller
            .call(api.getBoxDetails(macAddress))
            .then(({ data }) => {
                if (data.box) {
                    dispatch({
                        type: 'FHE__UPDATE_BOX',
                        box: data.box
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getBoxDetails - ', error);
                throw error;
            });
    };
}

function updateBox(middleware, macAddress) {
    return () => {
        return getSocket(middleware)
            .updateBox(macAddress)
            .catch(error => {
                Logger.log('dataActions: refreshBox - ', error);
                throw error;
            });
    };
}
function restartBox(middleware, macAddress) {
    return () => {
        return getSocket(middleware)
            .restartBox(macAddress)
            .catch(error => {
                Logger.log('dataActions: restartBox - ', error);
                throw error;
            });
    };
}
function startVpn(middleware, macAddress) {
    return () => {
        return getSocket(middleware)
            .startVpn(macAddress)
            .catch(error => {
                Logger.log('dataActions: startVpn - ', error);
                throw error;
            });
    };
}
function stopVpn(middleware, macAddress) {
    return () => {
        return getSocket(middleware)
            .stopVpn(macAddress)
            .catch(error => {
                Logger.log('dataActions: stopVpn - ', error);
                throw error;
            });
    };
}

function autocompleteBoxMac(macAddr) {
    return () => {
        return apiCaller
            .call(api.autocompleteBoxMac(macAddr))
            .then(({ data }) => {
                return data.boxes;
            })
            .catch(error => {
                Logger.log('dataActions: autocompleteBoxMac - ', error);
                throw error;
            });
    };
}
function dissociateBox(macAddress, homeId) {
    return dispatch => {
        return apiCaller
            .call(api.dissociateBox(macAddress, homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_BOX',
                        box: data.box
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: dissociateBox - ', error);
                throw error;
            });
    };
}
function associateBox(macAddress, homeId) {
    return dispatch => {
        return apiCaller
            .call(api.associateBox(macAddress, homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_BOX',
                        box: data.box
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: associateBox - ', error);
                throw error;
            });
    };
}
function updateBoxDetails(boxMac, boxForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateBoxDetails(boxMac, boxForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_BOX',
                        box: data.box
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateBoxDetails - ', error);
                throw error;
            });
    };
}
function logClientInterfaceConnection(homeId) {
    return () => {
        apiCaller.call(api.logClientInterfaceConnection(homeId)).catch(error => {
            Logger.log('dataActions: logClientInterface - ', error);
            throw error;
        });
    };
}
function refreshBox(middleware, macAddress) {
    return () => {
        return getSocket(middleware)
            .refreshBox(macAddress)
            .catch(error => {
                Logger.log('dataActions: refreshBox - ', error);
                throw error;
            });
    };
}

function enableZway(middleware, macAddress) {
    return () => {
        return getSocket(middleware)
            .enableZway(macAddress)
            .catch(error => {
                Logger.log('dataActions: enableZway - ', error);
                throw error;
            });
    };
}

function disableZway(middleware, macAddress) {
    return () => {
        return getSocket(middleware)
            .disableZway(macAddress)
            .catch(error => {
                Logger.log('dataActions: disableZway - ', error);
                throw error;
            });
    };
}

function changeUpgradeStatus(middleware, macAddress, action) {
    return dispatch => {
        return getSocket(middleware)
            .changeUpgradeStatus(macAddress, action)
            .then(() => {
                const upgrade = action === 'disable' ? 0 : 1;
                dispatch({
                    type: 'FHE__UPDATE_BOX_UPGRADE',
                    macAddress,
                    upgrade
                });
            })
            .catch(error => {
                Logger.log('dataActions: changeUpgrade - ', error.message);
                throw error;
            });
    };
}

function boxSwap({ mac, newMac, ...swapData }) {
    return dispatch => {
        return apiCaller
            .call(api.boxSwap(swapData))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `FHE__SWAP_BOX`,
                        payload: { homeId: swapData.homeId, mac, newMac }
                    });
                }
                if (data.sensorError) {
                    throw data.sensorError;
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: swapBox - ', error);
                throw error;
            });
    };
}

export {
    boxSwap,
    logClientInterfaceConnection,
    refreshBox,
    getBoxes,
    getBoxDetails,
    updateBox,
    autocompleteBoxMac,
    associateBox,
    dissociateBox,
    restartBox,
    startVpn,
    stopVpn,
    updateBoxDetails,
    enableZway,
    disableZway,
    changeUpgradeStatus
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Boxes/actions.js